import { useDispatch, useSelector } from 'react-redux'
import { compose } from 'redux'

import { useAppContext } from '@/App.context'
import Button from '@/components/form/Button'
import { FormattedNumberWithCurrency } from '@/components/FormattedNumberWithCurrency'
import { Translation } from '@/components/i18n/Translation'
import { getIsLeasing, getOrderTotalCost } from '@/ducks/shopOrderReducer'
import {
  decreaseStep,
  getIsCurrentStepValid,
  getIsFinalStep,
  getIsFirstStep,
  increaseStep,
} from '@/ducks/shopProgressReducer'
import withShopProductsLoaded from '@/hocs/withShopProductsLoaded'

import './progress-buttons.scss'

const ProgressButtons = () => {
  const dispatch = useDispatch()
  const isFirstStep = useSelector(getIsFirstStep)
  const isFinalStep = useSelector(getIsFinalStep)
  const isCurrentStepValid = useSelector(getIsCurrentStepValid)
  const { whiteLabel } = useAppContext()

  const isLeasing = useSelector(getIsLeasing)
  const { buying_sum, leasing_monthly } = useSelector(getOrderTotalCost)

  return (
    <div className={`progress-buttons wl-${whiteLabel}`}>
      <div className="progress-buttons__content">
        {/* @ts-ignore */}
        <Button onClick={() => dispatch(decreaseStep())} disabled={isFirstStep}>
          <Translation id="Previous" />
        </Button>

        <div className="order-sum">
          <p>
            <Translation id={isLeasing ? 'Monthly payment:' : 'Order sum:'} />
          </p>

          <p>
            <FormattedNumberWithCurrency amount={isLeasing ? leasing_monthly : buying_sum} />
          </p>
          <p />
        </div>
        <Button
          // @ts-ignore
          onClick={() => dispatch(increaseStep())}
          disabled={isFinalStep || !isCurrentStepValid}
        >
          <Translation id="Next" />
        </Button>
      </div>
    </div>
  )
}

export default compose(withShopProductsLoaded)(ProgressButtons)
